import { FunctionComponent } from 'react';

export const Card: FunctionComponent<{
	padding?: string;
	withHover?: boolean;
}> = ({ children, padding = 'p-4', withHover = false }) => (
	<div className={`w-full h-full bg-white rounded-md shadow-md ${withHover ? 'hover:shadow-lg' : ''} ${padding}`}>
		{children}
	</div>
);

Card.displayName = 'UI.Card.Card';

export const DividedCard: React.FunctionComponent<{
	withHover?: boolean;
}> = ({ children, withHover = false }) => (
	<div
		className={`w-full h-full bg-white rounded-md shadow-md ${
			withHover ? 'hover:shadow-lg' : ''
		} p-4 divide-y divide-gray-200`}
	>
		{children}
	</div>
);

DividedCard.displayName = 'UI.Card.DividedCard';
